<template>
  <img :src="qrCode" />
</template>

<script>
export default {
  data () {
    return {
      connection: null,
      qrCode: null
    }
  },
  props: ['url'],
  async created() {
    // get the QR code
    const results = await this.axios.get(this.url,
      // { headers: `Authorization Bearer ${this.$auth.token()}` },
    ).catch((err) => {
      if (err) console.log(err);
      console.log(results);
    });
    this.qrCode = results.data;

    this.connection = new WebSocket('ws://localhost:8081/socket/test')

    this.connection.onoopen = function(event) {
      console.log(event)
      console.log('connection successful')
      this.connection.send('url param goes here')
    }
  }
}
</script>